import React from 'react';
import { Info, AlertTriangle, Lightbulb } from 'lucide-react';
interface InfoBoxProps {
  type: 'info' | 'warning' | 'tip';
  title?: string;
  children: React.ReactNode;
}
export function InfoBox({
  type,
  title,
  children
}: InfoBoxProps) {
  const config = {
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      iconColor: 'text-blue-500',
      titleColor: 'text-blue-900',
      Icon: Info
    },
    warning: {
      bg: 'bg-amber-50',
      border: 'border-amber-500',
      iconColor: 'text-amber-500',
      titleColor: 'text-amber-900',
      Icon: AlertTriangle
    },
    tip: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      iconColor: 'text-green-500',
      titleColor: 'text-green-900',
      Icon: Lightbulb
    }
  };
  const {
    bg,
    border,
    iconColor,
    titleColor,
    Icon
  } = config[type];
  return <div className={`my-6 flex p-4 rounded-r-lg border-l-4 ${bg} ${border}`} data-id="element-221">
      <div className="flex-shrink-0 mr-3 mt-0.5" data-id="element-222">
        <Icon className={`w-5 h-5 ${iconColor}`} data-id="element-223" />
      </div>
      <div data-id="element-224">
        {title && <h4 className={`text-sm font-bold mb-1 ${titleColor}`} data-id="element-225">{title}</h4>}
        <div className="text-sm text-gray-700 leading-relaxed" data-id="element-226">{children}</div>
      </div>
    </div>;
}